import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

export const AdminProjectOwnerDetails = observer(
  ({ projects, projectsToChange, setProjectToChange, allProjectsSelected, setAllProjectsSelected, clear }) => {
    useEffect(() => {
      return () => clear();
    }, []);

    return (
      <table className="usa-table usa-table--borderless">
        <thead className="">
          <tr className="projectOwner-table-head">
            <th scope="col">
              <input
                type="checkbox"
                name="allProjectsSelected"
                value="all"
                checked={allProjectsSelected}
                onChange={setAllProjectsSelected}
              />
            </th>
            <th scope="col" className="nobr">
              Project Name
            </th>
            <th scope="col">Type</th>
            <th scope="col">Status</th>
            <th scope="col">Last Updated</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {projects.map((project) => (
            <tr key={project.projectUuid}>
              <th scope="row">
                <input
                  type="checkbox"
                  name="projectToChange"
                  value={project.projectUuid}
                  onChange={setProjectToChange}
                  checked={projectsToChange.has(project.projectUuid)}
                />
              </th>
              <td>{project.projectTitle}</td>
              <td>{project.projectClassType}</td>
              <td>{project.projectStatus}</td>
              <td>{new Date(project.lastChangedDate).toLocaleString('en-US')}</td>
              <td>
                <Link to={`/projects/${project.projectUuid}`} className="usa-button--unstyled">
                  View
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
);
